
import { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { TinModalHeader } from "../../configs";
import { useState } from 'react';
import { useForm } from "react-hook-form";
import { ApiSchemaUpdateTin } from "../../models";
import { FormErrorMessage } from "../../components";
import { useFunctionalityExists } from "../../pages/hooks/functionalityExists";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  modalHeader: string;
  userTin?: string;
  onSaveHandler: any;
  onDeleteTin: () => Promise<void>;
  itemName: string | null;
};

export function ModalUserTin(props: Props): JSX.Element {
  const { handleShow, modalHeader, userTin, onSaveHandler } = props;
  const { register, formState: { errors }, reset } =
    useForm<ApiSchemaUpdateTin>();
  const [onClickEditTin, setOnClickEditTin] = useState(false);
  const [tinInput, setTinInput] = useState(userTin || "");
  const [tinError, setTinError] = useState("")
  const [lenghtError, setlenghtError] = useState("")
  const [buttonDisabled, setButtonDisabled] = useState(false)


  const { onTinExists } = useFunctionalityExists();

  const onTinSubmitHandler = async (tin: string) => {
    setButtonDisabled(true)
    var tinElem = document?.getElementById("tin") as HTMLInputElement
    var tinElemvalue = tinElem.value

    await onTinExists(tinElemvalue, userTin)
      .then((r) => {

        if (r) setTinError("TIN Already Exists")
        else setTinError("")

        if (!r) onSaveHandler(tinElemvalue);
      })

    setButtonDisabled(false)
  };

  const tinCallBack = (cb: any) => {
    return cb();
  }
  const onModalClose = () => {
    handleShow(false);
    setOnClickEditTin(false);
    reset({ tin: "" });
  };

  const onTinExistsValidation = async (value: any) => {
    setButtonDisabled(true)
    await onTinExists(value, userTin)
      .then((r) => {
        if (r) setTinError("TIN Already Exists")
        else setTinError("")
      })
    setButtonDisabled(false)


  }

  const onValidateLength = (value: any) => {
    if (value.length < 3 || value.length > 5) {
      setlenghtError("Please enter minimun 3 digits to maximum 5 digits")
    }
    else {
      setlenghtError("")
    }

  };

  return (
    <Modal show={props.show} onHide={() => onModalClose()} centered backdrop='static'>
      <Modal.Header closeButton>
        <Modal.Title className="test-modal">{modalHeader}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          <div className="col-12">
            {props.itemName && <p>TIN for: <span className="ghost-pill">{props.itemName}</span></p>}

            {modalHeader === TinModalHeader.userTin && !onClickEditTin ? <div className="d-flex flex-wrap justify-content-center align-items-center">
              {
                userTin &&
                tinCallBack(() => {
                  const row = [];
                  for (var i = 0; i < userTin.length; i++) {
                    row.push(<div className="TINbox">
                      <span className="TIN-number">
                        {userTin[i]}
                      </span>
                    </div>);
                  }
                  return row;
                })
              }
            </div> : <div className="form-group">
              <label htmlFor="" className="position-relative required">
                Type Tin
              </label>
              <input
                type="text"
                {...register('tin', { required: true, minLength: 3, maxLength: 5, })}
                className="form-control"
                placeholder="Tin"
                defaultValue={userTin}
                id="tin"
                minLength={3}
                maxLength={5}
                onChange={(e) => {
                  onTinExistsValidation(e.target.value)
                  onValidateLength(e.target.value)
                  console.log("Value ", e.target.value)
                }} />
              {tinError && <FormErrorMessage message={tinError} />}
              {lenghtError && <FormErrorMessage message={lenghtError} />}
              {errors.tin && errors.tin.type === "required" && <FormErrorMessage message="required" />}
              {errors.tin && errors.tin.type === "minLength" && <FormErrorMessage message="Please enter at least 3 numbers." />}
              {errors.tin && errors.tin.type === "maxLength" && <FormErrorMessage message="Please enter less than 6 numbers." />}


            </div>}
          </div>


        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="w-100 d-flex justify-content-between">
          <div>
            {modalHeader === TinModalHeader.userTin && !onClickEditTin && (
              <button
                type="button"
                className="btn btn-danger text-uppercase user-from-delete-btn"
                onClick={async () => {
                  await props.onDeleteTin();  
                  onModalClose();             
                }}
              >
                Delete tin
              </button>
            )}
          </div>
          <div>
            {modalHeader === TinModalHeader.userTin && !onClickEditTin && (
              <button
                type="button"
                className="btn btn-outline-dark text-uppercase"
                onClick={() => {
                  setOnClickEditTin((prev) => !prev);
                }}
              >
                Edit tin
              </button>
            )}
            <button
              type="button"
              className="ml-2 btn btn-primary text-uppercase"
              onClick={() => onModalClose()}
            >
              Close
            </button>
            {(modalHeader === TinModalHeader.createTin || onClickEditTin) && (
              <button
                type="button"
                disabled={buttonDisabled}
                className="ml-2 btn btn-primary text-uppercase user-from-submit-btn"
                onClick={() => {
                  onTinSubmitHandler(tinInput);
                }}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
